import React, { useRef, useEffect } from "react";
import { useGLTF } from "@react-three/drei";
import { useSnapshot } from "valtio";
import { setLoadingState, state } from "../../utils/state";
import { LightenDarkenColor } from "../../utils/helpers";

export default function Bombito({ hide, ...props }) {
  const group = useRef();
  const { nodes, materials } = useGLTF("/bombito.glb");
  const {
    color,
    modelLoading: { zamia, bases },
  } = useSnapshot(state);

  useEffect(() => {
    if (zamia && bases) {
      console.log("Preloading Bombito");
      useGLTF.preload("/bombito.glb");
    }
  }, [zamia, bases]);

  useEffect(() => {
    if (nodes) {
      console.log("Loaded Bombito");
      setLoadingState("bombito", true);
    }
  }, [nodes]);

  if (hide) return null;

  return (
    <group ref={group} {...props} dispose={null}>
      <mesh
        castShadow
        geometry={nodes.Bombito.geometry}
        material={materials.Paint}
        material-color={
          color !== "stroke"
            ? color === "#15110A" || color === "#005D6F"
              ? color
              : LightenDarkenColor(color, -60)
            : "#ffffff"
        }
        material-envMapIntensity={0.8}
      />
    </group>
  );
}
